import {useCallback, useEffect, useRef} from "react";
import {dataLayerPush} from "@/Helpers/Function";

export default function useViewItemBatcher() {
    const viewed = useRef(new Set()); // уже отправленные товары
    const buffer = useRef([]); // временный буфер новых товаров
    const timer = useRef(null);

    const flush = useCallback(() => {
        if (buffer.current.length === 0) return;

        const itemsToSend = [...buffer.current];
        buffer.current = [];

        dataLayerPush('view_item_list', 'catalog', 'viewItemList', 'product', '', itemsToSend);
    }, []);

    const scheduleFlush = useCallback(() => {
        if (timer.current) return; // уже ждём
        timer.current = setTimeout(() => {
            flush();
            timer.current = null;
        }, 1000); // батч каждую секунду
    }, [flush]);

    const registerView = useCallback(
        (product) => {
            if (viewed.current.has(product.id)) return; // уже отправлен
            viewed.current.add(product.id);
            buffer.current.push({
                ...product,
                product_id: product.id,
                count: 1,
                price: product.minimumPrice !== 0 ? product.minimumPrice : product.card_price
            });
            scheduleFlush();
        },
        [scheduleFlush]
    );

    // Очистка при размонтировании
    useEffect(() => () => clearTimeout(timer.current), []);

    return {registerView};
}
